import React from 'react'

export default function FreeEdition(props) {
  return (
    <div className={(props.center ? 'game-free-center ' : '' + (props.scale ? 'game-free-scale' : ''))} style={{display:'inline-block',position:'relative'}}>
      {props.children?.is_free_edition && !props?.gameDetail && <div style={{position:'relative',display:'inline-block'}}>
        <img src="resources/250410/free-edition.png" alt="" height={14}/>
      </div>}
      {props.children?.is_free_edition && props?.gameDetail && <div style={{position:'relative',display:'inline-block'}}>
        <img src="resources/250410/free-edition-detail.png" alt="" height={46}/>
        <div style={{fontSize:'10px',color:'white',textAlign:'center',position:'absolute',left:'0',right:'0',bottom:'7px'}}>{props.children?.discount * 10}折</div>
      </div>}
      {props.children?.discount < 1 && props?.gameDetail && !props.children?.is_free_edition && props.children.goodGame?.length == 0 &&
        <div style={{position:'relative',display:'flex',alignItems:'baseline',color: '#FF3F44',justifyContent:'center'}}>
          <span style={{fontSize: '17px',fontWeight:'600',}}>{props.children.discount * 10}</span>
          <span style={{fontSize: '11px'}}>折</span>
        </div>}
      {props.children?.discount < 1 && !props.center && !props?.gameDetail && !props.children?.is_free_edition && 
      <div style={{position:'relative',display:'flex',alignItems:'baseline',color: '#FF3F44',justifyContent:'center'}}>
        <span style={{fontSize: '17px',fontWeight:'600',}}>{props.children.discount * 10}</span>
        <span style={{fontSize: '11px'}}>折</span>
      </div>}
      {props.children?.discount < 1 && props.center && !props?.gameDetail && !props.children?.is_free_edition && 
        <div style={{position:'relative',display:'flex',alignItems:'baseline',color: '#FF3F44',justifyContent:'center'}}>
          <span style={{fontSize: '17px',fontWeight:'600',}}>{props.children.discount * 10}</span>
          <span style={{fontSize: '11px'}}>折</span>
        </div>}
      {props.children.goodGame?.length > 0 && !props.children?.is_free_edition && props?.gameDetail ? <div className="goodGame">
        <img className="goodgame-icon" src="resources/index/left.png" alt="" />
        <div className="goodgame-content">
          <div className="goodgame-title">
            <div className="goodgame-name">{props.children.discount * 10}</div>
            <div className="goodgame-desc">折</div>
          </div>
          <div className="goodgame-text">{props.children.goodGame}</div>
        </div>
        <img className="goodgame-icon" src="resources/index/right.png" alt="" />
      </div> : null}
    </div>
  )
}
